import { api } from "../config";


export const apiCallsDashboard = {
  Actions: {
    GetCountsDevices: async () => {
      try {
        const response = await api.get("Dashboard/count", {
          params: {
            search : "",
            nsApplication: process.env.REACT_APP_NS_APPLICATION
          }
        });
        if (response.data) {
          return response.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },

    GetgatewaysInfo: async () => {
      try {
        const response = await api.get("Dashboard/gateways-info", {
          params: {
            nsApplication: process.env.REACT_APP_NS_APPLICATION
          }
        });
        if (response.data) {
          return response.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },

    GetTotalConsumptionForNEMAAndPillars: async (filters) => {
      try {
        const fromDateTime = filters.fromDate.hour(filters.fromTime.hour()).minute(filters.fromTime.minute()).second(filters.fromTime.second() || 0);
        const toDateTime = filters.toDate.hour(filters.toTime.hour()).minute(filters.toTime.minute()).second(filters.toTime.second() || 0);
        const fromDateFormat = fromDateTime.toISOString();
        const toDateFormat = toDateTime.toISOString();
        const response = await api.get("Dashboard/total-consumption", { 
          params: {
            Search: "",
            DateFrom: fromDateFormat, 
            DateTo: toDateFormat,
            HourFrom: filters.fromTime.hour(),
            HourTo: filters.toTime.hour(),
            nsApplication: process.env.REACT_APP_NS_APPLICATION
          }
        });
        if (response.data) {
          return response.data;
        }
      } catch (error) {
          console.error(error);
      }
    },

    GetLatestPayloads: async () => {
      try {
        const response = await api.get("Dashboard/latest-payloads", {
          params:{
            nsApplication: process.env.REACT_APP_NS_APPLICATION
          }
        });
        if (response.data) {
          return response.data.data;
        }
      } catch (error) {
          console.error(error);
      }
    },

  },

};